import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Spinner } from '../../components/UI';
import { SectionIcon } from '../../components/TrainerUI';
import { fmtDateTime } from '../../utils/format';

const ReadOnlyNote = ({ children }) => (
  <div className="trn-readonly-note">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" />
    </svg>
    {children}
  </div>
);

const FIELDS = [
  ['full_name', 'Full Name'],
  ['username',  'Username'],
  ['email',     'Email'],
  ['phone',     'Mobile No.'],
  ['dept_name', 'Department'],
];

export default function TrainerProfilePage() {
  const [loading, setLoading] = useState(true);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/trainer/profile').then(res => {
      if (!cancelled) setProfile(res.data.data);
    }).finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  if (loading) return <div className="trn-page"><Spinner /></div>;

  return (
    <>
      <div className="trn-topbar">
        <div className="trn-topbar-title">My Profile</div>
        <div className="trn-topbar-sub">Your trainer record on file</div>
      </div>
      <div className="trn-page">
        <ReadOnlyNote>Your profile is managed by Admin. Contact the office to request changes.</ReadOnlyNote>

        <div className="trn-card">
          <div className="trn-card-head"><h3 className="d-flex align-items-center"><SectionIcon icon="bi-person-vcard" color="var(--sms-stat-blue)" />Trainer Information</h3></div>
          <div className="trn-card-body">
            <div className="trn-profile-grid">
              {FIELDS.map(([key, label]) => (
                <div key={key}>
                  <div className="trn-field-label">{label}</div>
                  <div className="trn-field-value">{profile?.[key] || '—'}</div>
                </div>
              ))}
              <div>
                <div className="trn-field-label">Last Login</div>
                <div className="trn-field-value">{profile?.last_login ? fmtDateTime(profile.last_login) : '—'}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
